import Excerpt from './Excerpt';

export const components = {
  Excerpt,
};
